import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

export const { name, version } = __serviceInfo__;

export class OffersService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export const serviceNames = {
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    httpTransport: 'HTTP_TRANSPORT',
    config: 'OFFERS_CONFIG',
    configRepository: 'OFFERS_CONFIG_REPOSITORY',
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    cartOffers: 'CART_OFFERS',
    offersApiSdk: 'OFFERS_API_SDK',
    offersRepository: 'OFFERS_REPOSITORY',
    offersViewController: 'OFFERS_VIEW_CONTROLLER',
    offersService: 'CART_SIDEBAR_OFFERS_SERVICE',
    offerCodeModuleViewController: 'CART_SIDEBAR_OFFER_CODES_MODULE_VIEW_CONTROLLER',
    samplesRepository: 'SAMPLES_REPOSITORY',
    samplesController: 'SAMPLES_VIEW_CONTROLLER',
    cartRepository: 'CART_REPOSITORY'
};
